import Dashlet from "../../../controls/Dashlet";
import { ComponentEx, translate } from "../../../controls/ComponentEx";
import opn from "../../../util/opn";
import { PREMIUM_PATH } from "../constants";
import * as React from "react";
import { Campaign, nexusModsURL, Section, Content } from "../../../util/util";
import FlexLayout from "../../../controls/FlexLayout";
import Image from "../../../controls/Image";
class GoPremiumDashlet extends ComponentEx {
    render() {
        const { t } = this.props;
        const premiumPictogramPath = "assets/pictograms/premium-pictogram.svg";
        return (React.createElement(Dashlet, { title: "", className: "dashlet-go-premium" },
            React.createElement(Image, { className: "premium-pictogram", srcs: [premiumPictogramPath] }),
            React.createElement("div", { className: "dashlet-premium-title" },
                "Get fast downloads with",
                " ",
                React.createElement("span", { className: "text-highlight" }, "premium")),
            React.createElement("div", { className: "dashlet-premium-body" },
                React.createElement("span", { className: "text-highlight" }, "Upgrade to unlock"),
                " uncapped download speeds,",
                React.createElement("span", { className: "text-highlight" },
                    " ",
                    "auto-install collections"),
                " and ",
                React.createElement("span", { className: "text-highlight" }, "no ads"),
                "."),
            React.createElement("button", { className: "dashlet-premium-button", onClick: this.goBuyPremium },
                React.createElement(FlexLayout, { type: "row", className: "dashlet-premium-button-content" },
                    t("Go Premium"),
                    React.createElement("div", { className: "arrow-forward" })))));
    }
    goBuyPremium = () => {
        this.context.api.events.emit("analytics-track-click-event", "Go Premium", "Dashlet");
        opn(nexusModsURL(PREMIUM_PATH, {
            section: Section.Users,
            campaign: Campaign.BuyPremium,
            content: Content.DashboardDashletAd,
        })).catch((err) => undefined);
    };
}
export default translate(["common"])(GoPremiumDashlet);
